import { render, staticRenderFns } from "./StudyRecord.vue?vue&type=template&id=48d64fbc&scoped=true"
import script from "./StudyRecord.vue?vue&type=script&lang=ts"
export * from "./StudyRecord.vue?vue&type=script&lang=ts"
import style0 from "./StudyRecord.vue?vue&type=style&index=0&id=48d64fbc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d64fbc",
  null
  
)

export default component.exports